define('SuiteDynamics.B2BPromoMessaging.HeaderModifications',
	[
		'Profile.Model',
		'underscore'
	],
	function (
		ProfileModel,
		_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			var layout = container.getComponent('Layout');
			var userProfileComp = container.getComponent('UserProfile');
			var environment = container.getComponent('Environment');
			if (layout && userProfileComp && environment) {
				userProfileComp.getUserProfile().then(function(profile) {
					var customFields = profile.customfields;
					var isB2B = _.findWhere(customFields || [], { id: 'custentity_ano_is_b2b' });
					layout.addToViewContextDefinition('Header.View', 'isB2B', 'boolean', function () {
						return isB2B && isB2B.value === true || isB2B.value === 'T';
					});
					layout.addToViewContextDefinition('Header.View', 'bannerTextB2B', 'string', function () {
						return environment.getConfig('header.bannerTextB2B') || '';
					});
				});
			}
		}
	};
});
